<template>
    <transition name="fade" mode="out-in">
        <component :is="authComponent"/>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import SingleSignOnForm from './forms/SingleSignOnForm';

    @Component
    export default class Authentication extends Vue {
        name = 'authentication';

        created() {
            console.log('[ Authentication ]', this.$auth.currentUser());
            if (this.$auth.currentUser() !== null) {
                const redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'home'
                    });
                }
            }
        }

        get authComponent() {
            return SingleSignOnForm;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/Authentication.vue